<template>

  <RouteProgressBar />
  <RouterView v-slot="{ Component, route }">
    <Transition name="route-fade" mode="out-in">
      <component :is="Component" :key="route.fullPath" />
    </Transition>
  </RouterView>
  <FooterComponent />
  <CookieBanner />

  <!-- Botón flotante de WhatsApp -->
  <a href="https://wa.me/5214624205146" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp"
    class="whatsapp-btn">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-7 h-7">
      <path
        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
    <span class="whatsapp-label">¿Hablamos?</span>
  </a>


  <!-- Notificacion -->

  <transition enter-active-class="transition duration-300 ease-out" enter-from-class="transform translate-y-2 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100" leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100" leave-to-class="transform translate-y-2 opacity-0">
    <div v-if="notification.show"
      class="fixed bottom-5 left-5 z-50 flex items-center gap-3 px-5 py-4 rounded-2xl shadow-xl border backdrop-blur-md transition-all"
      :class="{
        'bg-white/90 dark:bg-slate-900/90 border-green-500/30 text-slate-800 dark:text-white': notification.type === 'success',
        'bg-white/90 dark:bg-slate-900/90 border-red-500/30 text-slate-800 dark:text-white': notification.type === 'error',
        'bg-white/90 dark:bg-slate-900/90 border-yellow-500/30 text-slate-800 dark:text-white': notification.type === 'warning',
        'bg-white/90 dark:bg-slate-900/90 border-blue-500/30 text-slate-800 dark:text-white': notification.type === 'info',
      }">
      <!-- Icono dinámico -->
      <span class="material-symbols-outlined text-2xl"
        :class="{
          'text-green-500': notification.type === 'success',
          'text-red-500': notification.type === 'error',
          'text-yellow-500': notification.type === 'warning',
          'text-blue-500': notification.type === 'info'
        }">
        {{ notification.type === 'success' ? 'check_circle' : notification.type === 'error' ? 'error' : notification.type === 'warning' ? 'warning' : 'info' }}
      
      </span>

      <!-- Texto -->
      <div class="text-sm font-medium">
        {{ notification.message }}
      </div>
    </div>


  </transition>
</template>

<script setup>
import FooterComponent from '@/components/FooterComponent.vue';
import RouteProgressBar from '@/components/RouteProgressBar.vue';
import CookieBanner from '@/components/CookieBanner.vue';
import { useNotification } from './composables/useNotification'

const { notification } = useNotification()

</script>

<style>
/* ─── Route transitions ─────────────────────────────────── */
.route-fade-enter-active,
.route-fade-leave-active {
  transition: opacity 240ms ease, transform 240ms cubic-bezier(0.22, 1, 0.36, 1);
}

.route-fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.route-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* ─── Reveal up ─────────────────────────────────────────── */
.reveal-up {
  animation: reveal-up 560ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.reveal-up-delay-1 {
  animation-delay: 110ms;
}

.reveal-up-delay-2 {
  animation-delay: 220ms;
}

.reveal-up-delay-3 {
  animation-delay: 330ms;
}

.reveal-up-delay-4 {
  animation-delay: 440ms;
}

.reveal-up-delay-5 {
  animation-delay: 550ms;
}

@keyframes reveal-up {
  from {
    opacity: 0;
    transform: translateY(18px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ─── Reveal left ───────────────────────────────────────── */
.reveal-left {
  animation: reveal-left 560ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.reveal-left-delay-1 {
  animation-delay: 110ms;
}

.reveal-left-delay-2 {
  animation-delay: 220ms;
}

.reveal-left-delay-3 {
  animation-delay: 330ms;
}

@keyframes reveal-left {
  from {
    opacity: 0;
    transform: translateX(-24px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* ─── Reveal right ──────────────────────────────────────── */
.reveal-right {
  animation: reveal-right 560ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.reveal-right-delay-1 {
  animation-delay: 110ms;
}

.reveal-right-delay-2 {
  animation-delay: 220ms;
}

.reveal-right-delay-3 {
  animation-delay: 330ms;
}

@keyframes reveal-right {
  from {
    opacity: 0;
    transform: translateX(24px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* ─── Reveal scale ──────────────────────────────────────── */
.reveal-scale {
  animation: reveal-scale 500ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.reveal-scale-delay-1 {
  animation-delay: 110ms;
}

.reveal-scale-delay-2 {
  animation-delay: 220ms;
}

.reveal-scale-delay-3 {
  animation-delay: 330ms;
}

@keyframes reveal-scale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* ─── Reveal blur ───────────────────────────────────────── */
.reveal-blur {
  animation: reveal-blur 600ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.reveal-blur-delay-1 {
  animation-delay: 120ms;
}

.reveal-blur-delay-2 {
  animation-delay: 240ms;
}

@keyframes reveal-blur {
  from {
    opacity: 0;
    filter: blur(8px);
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    filter: blur(0px);
    transform: translateY(0);
  }
}

/* ─── Animated shimmer text ─────────────────────────────── */
.text-shimmer {
  background: linear-gradient(90deg,
      var(--primary, #0ea5e9) 0%,
      #7dd3fc 35%,
      #e0f2fe 50%,
      #7dd3fc 65%,
      var(--primary, #0ea5e9) 100%);
  background-size: 250% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: text-shimmer 3.5s linear infinite;
}

@keyframes text-shimmer {
  from {
    background-position: 0% center;
  }

  to {
    background-position: 250% center;
  }
}

/* ─── Typewriter cursor blink ───────────────────────────── */
.cursor-blink::after {
  content: '|';
  display: inline-block;
  margin-left: 2px;
  animation: cursor-blink 1s step-end infinite;
  color: var(--primary, #0ea5e9);
}

@keyframes cursor-blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

/* ─── WhatsApp flotante ─────────────────────────────────── */
.whatsapp-btn {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #25d366;
  color: #fff;
  padding: 0.75rem 1.25rem;
  border-radius: 9999px;
  font-weight: 700;
  font-size: 0.9rem;
  box-shadow: 0 8px 30px rgba(37, 211, 102, 0.4);
  text-decoration: none;
  transition: transform 200ms ease, box-shadow 200ms ease;
}

.whatsapp-btn:hover {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 12px 40px rgba(37, 211, 102, 0.55);
}

.whatsapp-btn:active {
  transform: scale(0.97);
}

/* ─── Reduced motion ────────────────────────────────────── */
@media (prefers-reduced-motion: reduce) {

  .route-fade-enter-active,
  .route-fade-leave-active {
    transition: none;
  }

  .reveal-up,
  .reveal-left,
  .reveal-right,
  .reveal-scale,
  .reveal-blur,
  [class*="reveal-up-delay-"],
  [class*="reveal-left-delay-"],
  [class*="reveal-right-delay-"],
  [class*="reveal-scale-delay-"],
  [class*="reveal-blur-delay-"] {
    animation: none;
  }

  .text-shimmer {
    -webkit-text-fill-color: var(--primary, #0ea5e9);
    animation: none;
  }

  .cursor-blink::after {
    animation: none;
  }
}
</style>
